import React from "react";
import Player from "react-player/youtube";

import Button from "../components/Button";

const BiddingVideo: React.FC = () => {
  return (
    <div className="mb-16">
      <div className="mx-auto max-w-[1024px] px-4 lg:flex lg:gap-16 lg:pb-6">
        <div className="relative mb-8 aspect-video w-full max-w-[464px] shrink-0 lg:mb-0">
          <div className="absolute -bottom-6 -left-6 right-6 top-6 hidden rounded-md bg-black lg:block" />
          <div className="relative h-full w-full overflow-hidden rounded-md">
            <Player
              controls
              width="100%"
              height="100%"
              url="https://youtu.be/F93929-_8yQ"
              className="absolute inset-0"
            />
          </div>
        </div>
        <div>
          <h1 className="mb-4 text-3xl font-bold text-clhbid-orange">
            CLHbid Makes Bidding Simple
          </h1>
          <p className="mb-6">
            The absolute transparency of this innovative format is a huge
            benefit to all parties involved. Bidders bid from the privacy of
            their own home on a set day.
          </p>
          <p className="mb-6">
            The sale starts and finishes in a matter of hours and the time will
            extend if bids are placed in the last two minutes of the sale. As
            confidentiality and honesty are paramount to us, bidders names are
            never released.
          </p>
          <Button href="/how-clhbid-works/bidding-on-properties-on-clhbid">
            Learn More
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BiddingVideo;
